document.addEventListener('DOMContentLoaded', function () {
  const stickyBanner = document.getElementById('sticky-banner')
  const pageElements = [
    document.querySelector('[id*="sleepdoctor_sharma_lp_hero"]'),
    document.querySelector('[id*="sleepdoctor_sharma_lp_featured_product"]'),
    document.getElementById('shopify-section-sleepdoctor-sharma-lp-footer')
  ]

  if (stickyBanner !== null) {
    const intersectionCallback = (entries, observer) => {
      let bannerVisible = true

      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          bannerVisible = false
        }
      })

      stickyBanner.style.display = bannerVisible ? 'block' : 'none'
    }

    const intersectionOptions = {
      root: null,
      threshold: 0.1
    }

    /* eslint-disable no-undef */
    const intersectionObserver = new IntersectionObserver(intersectionCallback, intersectionOptions)
    /* eslint-enable no-undef */

    if (pageElements[0] !== null) {
      pageElements.forEach((element) => {
        if (element !== null) {
          intersectionObserver.observe(element)
        }
      })
    }
  }
  /* eslint-disable no-unused-vars, no-undef */
  // Featured Product Slider Thumbnails
  const featuredProductThumbs = document.getElementById('featured-product-slider-thumb')
  if (featuredProductThumbs) {
    const swiperfpt = new Swiper('#featured-product-slider-thumb', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      watchSlidesVisibility: true,
      watchSlidesProgress: true
    })
  }

  // Featured Product Slider
  const featuredProductSlider = document.getElementById('featured-product-slider')
  if (featuredProductSlider) {
    const swiperfps = new Swiper('#featured-product-slider', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      thumbs: {
        swiper: featuredProductThumbs
      }
    })
  }

  // Review Slider Style 1
  const reviewSliderStyleOne = document.getElementById('review-slider')
  if (reviewSliderStyleOne) {
    const swiperrss1 = new Swiper('#review-slider', {
      spaceBetween: 10,
      pagination: {
        el: '.swiper-pagination',
        horizontalClass: '.swiper-ph',
        clickable: true
      },
      navigation: {
        nextEl: '.lp-image-with-review-next',
        prevEl: '.lp-image-with-review-prev'
      }
    })
  }

  // Review Slider Style 2
  const reviewSliderStyleTwo = document.getElementById('review-slider-peek')
  if (reviewSliderStyleTwo) {
    const swiperrss2 = new Swiper('#review-slider-peek', {
      spaceBetween: 20,
      slidesPerView: 1.1,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      breakpoints: {
        768: {
          slidesPerView: 2
        },
        1300: {
          slidesPerView: 3,
          touchRatio: 0
        }
      }
    })
  }

  // Review Slider Style 3
  const reviewSliderStyleThree = document.getElementById('review-slider-2col')
  if (reviewSliderStyleThree) {
    const swiperrss3 = new Swiper('#review-slider-2col', {
      spaceBetween: 20,
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.lp-image-with-review-next',
        prevEl: '.lp-image-with-review-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          touchRatio: 0
        }
      }
    })
  }

  // Review Slider Style 4
  const reviewSliderStyleFour = document.getElementById('review-slider-3col')
  if (reviewSliderStyleFour) {
    const swiperrss4 = new Swiper('#review-slider-3col', {
      spaceBetween: 20,
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      resizeObserver: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.lp-image-with-review-next',
        prevEl: '.lp-image-with-review-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          touchRatio: 0
        },
        1024: {
          slidesPerView: 3
        }
      }
    })
  }

  // Marquee Slider
  const marqueeSlider = document.getElementById('marquee-slider')
  if (marqueeSlider) {
    const swiperms = new Swiper('#marquee-slider', {
      spaceBetween: 0,
      centeredSlides: true,
      speed: 6000,
      autoplay: {
        delay: 0
      },
      loop: true,
      slidesPerView: 'auto',
      allowTouchMove: false,
      disableOnInteraction: true,
      observeParents: true,
      resizeObserver: true,
      breakpoints: {
        900: {
          centeredSlides: false,
          loop: false,
          autoplay: {
            enabled: false
          },
          slidesPerView: 4,
          spaceBetween: 50,
          touchRatio: 0
        }
      }
    })
    window.addEventListener('resize', function () {
      if (window.innerWidth < 900) {
        marqueeSlider.swiper.autoplay.start()
      } else {
        marqueeSlider.swiper.autoplay.stop()
      }
    })
  }

  // Content Slider
  const contentSlider = document.getElementById('content-slider')
  if (contentSlider) {
    const swipercs = new Swiper('#content-slider', {
      spaceBetween: 20,
      slidesPerView: 1.1,
      breakpoints: {
        500: {
          slidesPerView: 2
        },
        850: {
          slidesPerView: 3
        },
        1300: {
          slidesPerView: 4,
          touchRatio: 0
        }
      }
    })

    // Top Picks Sliders
    const topPicksSliders = document.querySelectorAll('.top-picks-slider')
    topPicksSliders.forEach(function (slider) {
      const swipertps = new Swiper(slider, {
        spaceBetween: 30,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        resizeObserver: true,
        breakpoints: {
          1300: {
            slidesPerView: 4,
            touchRatio: 0
          }
        }
      })
    })
  }

  const openCartDrawerEl = document.querySelector('[js-cart-drawer-open]')

  if (openCartDrawerEl) {
    openCartDrawerEl.addEventListener('click', function (evt) {
      evt.preventDefault()
      Rebuy?.SmartCart.show()
    })
  }

  document.addEventListener('rebuy:cart.add', (event) => {
    Rebuy?.SmartCart.show()
  })

  /* eslint-enable no-unused-vars, no-undef */
})
